<template>
  <div class="mb-md">
    <div
      v-if="showInitials"
      class="d-flex flex-column gap-xs">
      <p class="small-text">
        I understand that <span v-if="hasPromo">I will be charged {{ firstChargeAmount }} today, and </span>this subscription will
        automatically renew {{ chargeInterval }} at {{ renewalAmount }} unless I cancel the subscription
        service as set forth in the
        <TextLink to="https://support.armoire.style/legal/">Terms of Service</TextLink>.
        The price will not increase without prior notice. I can cancel by going to Account / Change Membership,
        and I must cancel before renewal to avoid being charged for the next renewal period.
      </p>
      <div class="d-flex gap-xxs small-text align-items-center">
        <div>Initials:</div>
        <InitialsInput
          v-model="initials"
          :required="showInitials"
          @valid="onValidInitials"/>
      </div>
    </div>
    <div
      v-else
      class="d-flex flex-column gap-xs">
      <BaseCheckbox
        v-model="consent"
        :input-value="false"
        text="I agree to automatic renewal."
        data-test="consent-checkbox"/>
      <p class="small-text">
        I understand I'll be charged <span v-if="hasPromo">{{ firstChargeAmount }} today, then </span>{{ renewalAmount }} {{ chargeInterval }}
        unless I cancel before renewal, as set forth in the
        <TextLink to="https://support.armoire.style/legal/">Terms of Service</TextLink>.
        I can cancel anytime in Account / Change Membership.
      </p>
    </div>
  </div>
</template>

<script setup>
import usePayment from '@shared/composables/payment.js'
import { formatPrice } from '@/utils/stringParsing.js'
import { computed } from 'vue'
import BaseCheckbox from '@/components/global/BaseCheckbox.vue'
import TextLink from '@shared/components/TextLink.vue'
import InitialsInput from '@/components/signUp/InitialsInput.vue'

defineOptions({
  compatConfig: {
    COMPONENT_V_MODEL: false
  }
})

const consent = defineModel({
  type: Boolean,
  required: true
})

const initials = defineModel('initials', {
  type: String,
  default: ''
})

const { membershipPlanSelected, total, chargeIntervalCopy } = usePayment()

const basePrice = computed(() => membershipPlanSelected.value?.basePrice / 100.0)
const firstChargeAmount = computed(() => formatPrice(total.value, true, true))
const renewalAmount = computed(() => formatPrice(basePrice.value, true, true))
const hasPromo = computed(() => total.value !== basePrice.value)
const chargeInterval = computed(() => membershipPlanSelected.value ? chargeIntervalCopy(membershipPlanSelected.value) : '')
const isPrepayPlan = computed(() => membershipPlanSelected.value?.chargeInterval !== 1)
const showInitials = computed(() => isPrepayPlan.value)

function onValidInitials(valid) {
  if (showInitials.value) {
    consent.value = valid
  }
}
</script>
